module.exports = __webpack_public_path__ + "media/assets/images/flags/gg-748c4dd0bb065b3c38226eb0e30b0d99.svg";